const getSystemTheme = () => {
  let primaryTheme = 'light';
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    primaryTheme = 'dark';
  }
  return primaryTheme;
};

export default getSystemTheme;
